module.exports = __webpack_public_path__ + "static/ar-logo100-web-black-3dbd3eeacd9b42ac1c3fedb205d9965e.svg";